import styled from '@emotion/styled'
import React from 'react'
import { HSpace } from 'components/layout/primitives'
import { ColorFamilyProps, FlexContainer, FlexMods, Overflow } from 'components/styles'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { CornerMods } from 'components/styles/primitives/modifiers/shape/corners'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { ColorPairs } from 'components/styles/definitions/colors/colorPairs'
import { Mods } from 'components/styles/primitives/core/mods'
import { ensureArray } from '../../../../../lib/types/arrays'

interface Props {
	decoration?: JSX.Element
	dark?: boolean
	className?: string
	size?: Sizes
}

type Sizes = 'big' | 'base'

const VARIANTS: Record<Sizes, any> = {
	big: [SizeMods({ height: '1.5rem' }), TextMods({ fontSize: '0.625rem' })],
	base: [SizeMods({ height: '1.25rem' }), TextMods({ fontSize: '0.75rem' })]
}

const PillView: React.FC<React.PropsWithChildren<Props & ColorFamilyProps & Mods>> = ({
	className,
	decoration = <HSpace space="smaller" />,
	children,
	size = 'base',
	modifiers
}) => (
	<FlexContainer
		modifiers={[...VARIANTS[size], ...ensureArray(modifiers)]}
		inline
		alignItems="center"
		gap="5px"
		className={className}
	>
		<HSpace space="smaller" />
		<Text>{children}</Text>
		{decoration}
	</FlexContainer>
)

export const Pill = styled(PillView)`
	transition: background-color 1s;
	${({ dark }) => (dark ? ColorPairs.whiteOnDark : ColorPairs.darkOnLight)};
	${Overflow.Hidden}
	${CornerMods.FullyRounded}
	${FlexMods.Child({ shrink: false })}
`

const Text = styled.p`
	font-weight: bold;
`
